import { render, staticRenderFns } from "./CarouselProductsBanner.vue?vue&type=template&id=51c7eafb&"
import script from "./CarouselProductsBanner.vue?vue&type=script&lang=js&"
export * from "./CarouselProductsBanner.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports